/**
 * @deprecated use wix-vod/wix-vod-api/src/private/enums
 * */
export let MEDIA_TYPES = /*#__PURE__*/function (MEDIA_TYPES) {
  MEDIA_TYPES["SECURE_VIDEO"] = "secure_video";
  MEDIA_TYPES["PICTURE"] = "picture";
  MEDIA_TYPES["VIDEO"] = "video";
  return MEDIA_TYPES;
}({});
//# sourceMappingURL=media-types.js.map